import { useMemo } from 'react';
import DOMPurify from 'dompurify';

interface SafeHtmlProps {
  html: string;
  className?: string;
}

/**
 * Вывод разметки, пришедшей с сервера. Сервер тоже чистит, но в браузер она попадает
 * через нас — поэтому санитайзим здесь, а не полагаемся на одну сторону.
 *
 * Разрешён минимум, которого хватает реквизитам для перевода: абзацы, переносы,
 * списки, выделение и ссылки. Скрипты, стили, iframe и обработчики событий вырезаются.
 */
export const SafeHtml = ({ html, className }: SafeHtmlProps) => {
  const clean = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'span', 'a'],
        ALLOWED_ATTR: ['href', 'target', 'rel'],
        ALLOW_DATA_ATTR: false,
      }),
    [html],
  );

  // eslint-disable-next-line react/no-danger
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};
